<script>
import GenericCrud from "@forms/GenericCrud.vue";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "TabelaCalculo"
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-input
          id="descricao"
          v-model="item.descricao"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Hora de início"
          label-for="horaInicio"
          class="col-md-6"
        >
          <b-form-input
            id="horaInicio"
            v-model="item.horaInicio"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Hora de término"
          label-for="horaFim"
          class="col-md-6"
        >
          <b-form-input
            id="horaFim"
            v-model="item.horaFim"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>
      </div>
      <b-form-group
        id="input-group-1"
        label="Razão de Sobreaviso"
        label-for="razaoSobreaviso"
      >
        <b-form-input
          id="razaoSobreaviso"
          v-model="item.razaoSobreaviso"
          type="number"
          step="0.01"
          min="0.00"
          max="1000.00"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Adicional Noturno"
        label-for="percentualAdicionalNoturno"
      >
        <b-form-input
          id="percentualAdicionalNoturno"
          v-model="item.percentualAdicionalNoturno"
          type="number"
          step="0.01"
          min="0.00"
          max="1000.00"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Adicional Sábado"
        label-for="percentualAdicionalSabado"
      >
        <b-form-input
          id="percentualAdicionalSabado"
          v-model="item.percentualAdicionalSabado"
          type="number"
          step="0.01"
          min="0.00"
          max="1000.00"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Adicional Domingo"
        label-for="percentualAdicionalDomingo"
      >
        <b-form-input
          id="percentualAdicionalDomingo"
          v-model="item.percentualAdicionalDomingo"
          type="number"
          step="0.01"
          min="0.00"
          max="1000.00"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Adicional Feriado"
        label-for="percentualAdicionalFeriado"
      >
        <b-form-input
          id="percentualAdicionalFeriado"
          v-model="item.percentualAdicionalFeriado"
          type="number"
          step="0.01"
          min="0.00"
          max="1000.00"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
